import { useState } from "react";
import { Trash2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { TextField, TextArea } from "@/components/form/Fields";

// Same layout as the Giveaway "Winner Details" box, edited locally and saved with the voucher
export function VoucherWinners({ value = [], onChange }) {
  const [w, setW] = useState({ name: "", contact_info: "", notes: "" });
  const add = () => {
    if (!w.name.trim()) return toast.error("Winner name is required");
    onChange([...value, { ...w, id: `new-${Date.now()}` }]);
    setW({ name: "", contact_info: "", notes: "" });
  };
  return (
    <div className="space-y-2 rounded-lg border border-amber-100 bg-amber-50/40 p-3" data-testid="voucher-winners">
      <p className="text-[11px] font-bold uppercase tracking-wide text-amber-700">Winner Details</p>
      {value.map((x, i) => (
        <div key={x.id || i} className="group rounded-md bg-white p-2 text-sm" data-testid={`voucher-winner-${i}`}>
          <div className="flex items-start gap-2">
            <div className="min-w-0 flex-1">
              <p className="font-semibold text-slate-800">{x.name}</p>
              {x.contact_info && <p className="text-xs text-slate-600">{x.contact_info}</p>}
              {x.notes && <p className="whitespace-pre-wrap text-xs text-slate-500">{x.notes}</p>}
            </div>
            <button type="button" onClick={() => onChange(value.filter((_, j) => j !== i))} className="opacity-60 hover:opacity-100" data-testid={`voucher-winner-delete-${i}`}><Trash2 className="h-3.5 w-3.5 text-slate-400 hover:text-red-500" /></button>
          </div>
        </div>
      ))}
      <div className="grid gap-2 sm:grid-cols-2">
        <TextField label="Name" value={w.name} onChange={(v) => setW({ ...w, name: v })} testid="voucher-winner-name" />
        <TextField label="Contact Info" value={w.contact_info} onChange={(v) => setW({ ...w, contact_info: v })} testid="voucher-winner-contact" placeholder="Email / phone" />
      </div>
      <TextArea label="Notes" value={w.notes} onChange={(v) => setW({ ...w, notes: v })} testid="voucher-winner-notes" rows={2} />
      <div className="flex justify-end"><Button type="button" size="sm" onClick={add} data-testid="voucher-winner-add" className="bg-amber-500 hover:bg-amber-600">Add Winner</Button></div>
    </div>
  );
}
